import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const contactsHeader = css`
  ${breakpoints.from.tablet} {
    margin-bottom: var(--space-300);
  }
  ${breakpoints.only.mobile} {
    margin-bottom: var(--space-150);
  }
`;

export const storeContactsContainer = css`
  grid-area: 3 / 1 / 4 / 2;
  ${breakpoints.to.desktop} {
    grid-area: 4 / 1 / 5 / 2;
  }
  ${breakpoints.only.tablet} {
    grid-area: 6 / 1 / 6 / 2;
  }
  ${breakpoints.to.tablet} {
    grid-area: 5 / 1 / 6 / 2;
  }
`;

export const contactsColumn = css`
  display: flex;
  flex-direction: column;
  ${breakpoints.only.tablet} {
    flex-direction: row;
    align-items: end;
  }
`;

export const contactsRow = css`
  ${breakpoints.from.tablet} {
    margin-bottom: var(--space-200);
  }
  ${breakpoints.only.mobile} {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const contactsTabletDiv = css`
  &:first-of-type {
    margin-bottom: 16px;
  }
  ${breakpoints.only.tablet} {
    width: 50%;
    margin-bottom: 0 !important;
  }
  & > .${contactsRow}:last-child {
    margin-bottom: 0;
  }
`;

export const iconAlign = css`
  margin-right: var(--space-200);
  vertical-align: top;
`;

export const businessHeader = css`
  ${breakpoints.from.tablet} {
    margin-bottom: var(--space-200);
  }
  ${breakpoints.only.mobile} {
    margin-bottom: var(--space-150);
  }
  ${breakpoints.from.desktop} {
    margin-top: var(--space-200);
  }
`;

export const silentLink = css`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: var(--text-primary);
  transition: 0.3s;
  svg {
    --i-color: var(--text-primary);
  }
  &:hover {
    color: var(--brand-dark) !important;

    svg {
      color: var(--brand-dark);
      --i-color: var(--brand-dark);
    }
  }
`;
